import { ResourcePage } from "@/components/resource-page"
import { z } from "zod"
import { Puzzle } from "lucide-react"

const featureSchema = z.object({
  name: z.string().min(1, "Name is required"),
  enabled: z.boolean().optional(),
  category: z.string().optional(),
  description: z.string().optional(),
})

const featureColumns = [
  { key: "id", type: "text", options: { label: "ID" } },
  { key: "name", type: "text", options: { label: "Name" } },
  { key: "enabled", type: "boolean", options: { label: "Enabled" } },
  { key: "category", type: "status", options: { label: "Category" } },
  { key: "description", type: "text", options: { label: "Description" } },
  { key: "updated_at", type: "date", options: { label: "Updated" } },
]

const featureFormFields = [
  { name: "name", label: "Name", type: "text", placeholder: "feature_name" },
  {
    name: "enabled",
    label: "Enabled",
    type: "select",
    options: [
      { value: "true", label: "Enabled" },
      { value: "false", label: "Disabled" },
    ],
  },
  {
    name: "category",
    label: "Category",
    type: "select",
    options: [
      { value: "configs", label: "Configs" },
      { value: "proxy", label: "Proxy" },
      { value: "scanner", label: "Scanner" },
      { value: "tools", label: "Tools" },
      { value: "marketing", label: "Marketing" },
      { value: "payment", label: "Payment" },
    ],
  },
  { name: "description", label: "Description", type: "text", placeholder: "Feature description" },
]

export default function FeaturesPage() {
  return (
    <ResourcePage
      resource="r/features"
      title="Features"
      icon={Puzzle}
      columns={featureColumns}
      formFields={featureFormFields}
      formSchema={featureSchema}
      searchPlaceholder="Search features..."
    />
  )
}
